import { render, staticRenderFns } from "./understand.vue?vue&type=template&id=0cdd2379&scoped=true"
import script from "./understand.vue?vue&type=script&lang=js"
export * from "./understand.vue?vue&type=script&lang=js"
import style0 from "./understand.vue?vue&type=style&index=0&id=0cdd2379&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd2379",
  null
  
)

export default component.exports